import { render, staticRenderFns } from "./ReportButtons.vue?vue&type=template&id=632d4d08&"
import script from "./ReportButtons.vue?vue&type=script&lang=js&"
export * from "./ReportButtons.vue?vue&type=script&lang=js&"
import style0 from "./ReportButtons.vue?vue&type=style&index=0&id=632d4d08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports